import { render, staticRenderFns } from "./store-category-item.vue?vue&type=template&id=dc545438&scoped=true&"
import script from "./store-category-item.vue?vue&type=script&lang=js&"
export * from "./store-category-item.vue?vue&type=script&lang=js&"
import style0 from "./store-category-item.vue?vue&type=style&index=0&id=dc545438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc545438",
  null
  
)

/* custom blocks */
import block0 from "./store-category-item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports